import { useMemo, useState } from 'react';
import { ProductCheckListFilterSection } from '../types';

export const useExpandedFiltersSectionsState = () => {
    const [expandedSections, setExpanded] = useState<Record<ProductCheckListFilterSection, boolean>>({
        [ProductCheckListFilterSection.Products]: true,
        [ProductCheckListFilterSection.Reservations]: false,
        [ProductCheckListFilterSection.AdvancedSettings]: false,
    });

    return useMemo(
        () => ({
            expandedSections,
            toggleExpandedSection: (section: ProductCheckListFilterSection) => {
                setExpanded((current) => ({ ...current, [section]: !expandedSections[section] }));
            },
        }),
        [expandedSections]
    );
};
